export type CampaignItemModel = {
  cache_key: number,
  campaign_id?: number,
  campaign_quote_id?: number,
  custom_item_id?: number,
  data?: {
    artwork_id?: number,
    campaign_quote_item_id?: number,
    created_by_artwork?: boolean,
    order_item_task_id?: number,
    paid_by?: string,
    price_override?: number,
  },
  dates?: {
    created: { date_time: string },
    due: { date: string, date_time: string },
    required: { date: string, date_time: string },
    updated: { date: string, date_time: string },
  },
  id: number,
  invoice_date?: string,
  invoice_notes?: string,
  invoice_reference?: string,
  invoice_total?: number,
  item_type?: 'custom',
  paid_by?: string,
  price?: number,
  price_override?: number,
  tax_rate?: number,
  title?: string,
  user_id?: number,
}

export type CampaignItemRequestOptions = {}

const state = {
  id: null,
  campaign_id: undefined,
  campaign_quote_id: undefined,
  custom_item_id: undefined,
  data: {},
  invoice_date: '',
  invoice_notes: '',
  invoice_reference: '',
  invoice_total: undefined,
  item_type: 'custom',
  paid_by: '',
  price: 0,
  price_override: 0,
  tax_rate: 10,
  title: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'title' },
]

export default state
